<mat-sidenav-container class="sidenav-container mat-typography paracelsus-theme">

  <!-- Боковое меню -->
  <mat-sidenav #sideNav mode="over" position="end" opened="false">
    <button mat-icon-button (click)="sideNav.close()" class="close-btn">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
    <app-side-nav (closeMenu)="closeSidenav()"></app-side-nav>
  </mat-sidenav>

   <!-- Основной контент -->
  <mat-sidenav-content>
    <div class="app-container flexible-growing">

      <mat-toolbar class="oep-toolbar">
        <div class="container-logo" (click)="goHome()">
          <img class="logo" [src]="logo" alt="logo" title="Платформа онлайн обучения"/>
          <img class="logo" src="assets/icons/paracelsus_logo.svg" alt="logo" title="title"/>
        </div>
        <div class="container-toolbar">
          <ng-container *ngIf="deviceType === 'mobile'">
            <button mat-icon-button (click)="toggleSidenav()" color="primary">
              <mat-icon class="primary-icon icon clickable" svgIcon="dots"></mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="deviceType !== 'mobile'">
            <div class="profile">
              <span>{{ (profile$ | async)?.fullName }}</span>
            </div>
            <button mat-icon-button (click)="logout()" color="primary">
              <mat-icon class="icon logout" svgIcon="exit"></mat-icon>
            </button>
          </ng-container>
        </div>
      </mat-toolbar>

      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>




